import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const TransactionFeeProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseTransactionFees/GetByFranchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseTransactionFees/Get/${props.feeId}`, method: 'GET', secure: true });
    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseTransactionFees/${props.franchiseTransactionFeeId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseTransactionFees`, method: 'POST', payload: props.transactionFee, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseTransactionFees`, method: 'POST', payload: props.transactionFee, secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const value = { listRecords, selectRecord, data, clearData, deleteRecord, createRecord, updateRecord, newRecord };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTransactionFeeStore = () => React.useContext(Context);